var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultfood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 620.37 481.19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeMiterlimit: 0,
    strokeWidth: 11.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "m424.96 328.69a172.76 172.76 0 1 1 -40.845 -260.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.74 131.37a128.63 128.49 0 1 1 99.016 210.54"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m450.83 139.1l0.5103-44.028s-0.76544-8.8056 6.3787-8.8056c6.889 0 5.6132 8.8056 5.6132 8.8056l-0.2551 44.028s-0.76544 4.4028 5.1029 4.6618c5.8684 0.25899 4.8478-4.9208 4.8478-4.9208l-0.2551-43.251s-0.51028-9.3236 5.6132-9.3236 4.8478 9.5826 4.8478 9.5826v44.287s1.9136 3.8201 6.1235 3.6258c4.2099-0.19423 4.9116-3.6906 5.0392-3.5935l0.5741-44.06s0-9.3236 5.3581-9.5826c5.3581-0.25899 5.3581 9.5826 5.3581 9.5826l-0.2552 46.618s2.857 37.662-14.587 40.195c-15.44 2.242 6.0918 133.94 0.3352 137.86-5.4456 3.7071-6.8089 4.3584-11.912 4.6174-5.1029 0.25897-10.095-1.5978-13.355-5.3499-6.0064-6.9126 13.083-136.23 1.5384-137.9-15.044-2.1796-16.876-43.311-16.621-43.052z",
    fillRule: "evenodd",
    strokeWidth: 5.883
  })), /*#__PURE__*/React.createElement("g", {
    strokeWidth: 5.883
  }, /*#__PURE__*/React.createElement("path", {
    d: "m81.745 112.33a16.92 33.367 0 1 1 0.90306 66.483",
    fill: "none",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m53.905 111.24c6.889-13.208 20.922-15.372 27.046-15.372 6.1235 0 22.619 1.4733 27.301 16.408 4.7411 15.125 2.6019 84.28-14.842 86.813-15.44 2.242 6.0918 133.94 0.3352 137.86-5.4456 3.7071-6.8089 4.3584-11.912 4.6174-5.1029 0.259-9.5899-0.58762-12.85-4.3398-6.0064-6.9126 12.578-135.72 1.0333-137.4-15.044-2.1796-23-75.387-16.11-88.595z",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultfood);
export default __webpack_public_path__ + "static/media/defaultfood.3dba2eead03fd300d0bf98c0d613cd02.svg";
export { ForwardRef as ReactComponent };